import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const useCarPrizeDrawExperiment = () => {
  const isCarPrizeDrawEnabled = useBinaryExperiment(FLAG.CAR_PRIZE_DRAW, { triggerExperiment: true });

  return { isCarPrizeDrawEnabled };
};
